var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClickedOverviewVehicleTrackingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3C1 1.89543 1.89543 1 3 1H19H19.2435C20.0473 1 20.8176 1.32259 21.3815 1.89545L26.138 6.72745C26.6904 7.28864 27 8.04453 27 8.832V9.12698V31C27 32.1046 26.1046 33 25 33H3C1.89543 33 1 32.1046 1 31V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1213 6.62132L21.8787 1.87868C21.3161 1.31607 20.553 1 19.7574 1H19V7.5C19 8.60457 19.8954 9.5 21 9.5H27V8.74264C27 7.94699 26.6839 7.18393 26.1213 6.62132Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1213 6.62132L21.8787 1.87868C21.3161 1.31607 20.553 1 19.7574 1H19V7.5C19 8.60457 19.8954 9.5 21 9.5H27V8.74264C27 7.94699 26.6839 7.18393 26.1213 6.62132Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.05C5 7.4701 5.4701 7 6.05 7H14.5382C15.1181 7 15.5882 7.4701 15.5882 8.05C15.5882 8.6299 15.1181 9.1 14.5382 9.1H6.05C5.4701 9.1 5 8.6299 5 8.05Z",
    fill: "#11334E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.35C5 13.7701 5.4701 13.3 6.05 13.3H21.95C22.5299 13.3 23 13.7701 23 14.35C23 14.9299 22.5299 15.4 21.95 15.4H6.05C5.4701 15.4 5 14.9299 5 14.35Z",
    fill: "#11334E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20.65C5 20.0701 5.4701 19.6 6.05 19.6H21.95C22.5299 19.6 23 20.0701 23 20.65C23 21.2299 22.5299 21.7 21.95 21.7H6.05C5.4701 21.7 5 21.2299 5 20.65Z",
    fill: "#11334E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 26.95C5 26.3701 5.4701 25.9 6.05 25.9H21.95C22.5299 25.9 23 26.3701 23 26.95C23 27.5299 22.5299 28 21.95 28H6.05C5.4701 28 5 27.5299 5 26.95Z",
    fill: "#11334E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickedOverviewVehicleTrackingIcon);
export default __webpack_public_path__ + "static/media/ClickedOverviewVehicleTrackingIcon.226bb5462bda63b8b67e3389d97d9e59.svg";
export { ForwardRef as ReactComponent };